export default __webpack_public_path__ + "static/am-world-map-06cc3c9b6e94f0aaad83b9d8248559db.png";